import createFuzzySearch from "@nozbe/microfuzz";
import { useMemo } from "react";

import type { ItemWithInsured } from "./use-pinned-insureds";

/**
 * Fuzzy-match `items` by insured name. Shared by the per-list book filtering and the book-wide
 * search hook so both spell "matches the insured term" the same way. `getName` must be
 * module-level, or the index rebuilds on every render.
 */
export const useFuzzyInsuredSearch = <T>(items: T[], term: string, getName: (item: T) => string) => {
  const fuzzySearch = useMemo(
    () => createFuzzySearch(items, { getText: (item: T) => [getName(item)], strategy: "smart" }),
    [items, getName]
  );

  return useMemo(() => (term ? fuzzySearch(term).map((result) => result.item) : items), [fuzzySearch, term, items]);
};

const getItemInsuredName = <T>(item: ItemWithInsured<T>) => item.insured.name;

export const useFilteredInsureds = <T>(items: ItemWithInsured<T>[], term: string) =>
  useFuzzyInsuredSearch(items, term, getItemInsuredName);
